import Agenda from 'components/utilized/dashboard/Agenda'
import AcademicCalendar from 'components/utilized/dashboard/AcademicCalendar'
import WhatINeed from 'components/utilized/studentDashboard/WhatINeed'
import Attendance from 'components/utilized/dashboard/Attendance'
import Grades from 'components/utilized/dashboard/Grades'
import Courses from 'components/utilized/studentDashboard/Courses'
import { Box, Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useGET_mySchoolQuery } from 'redux/api/mySchoolApi'
import { PRIMARY_YELLOW, PRIMARY_GREEN, PURE_BLACK, PRIMARY_PINK } from 'utils/customizedTheme'
import { useMedia } from 'utils/customHooks/useMedia'
import agenda from 'assets/images/agenda.jpg'
import calendar from 'assets/images/calendar.png'
import { useGET_subjectsQuery } from 'redux/api/subjectsApi'
import { MAX_PER_PAGE } from 'utils/constants'


const StudentDashboardPage = () => {

  const { isUnder1200px,isUnder900px } = useMedia()

  const topBoxStyle = {
    height: isUnder1200px ? '100%' : '100%',
    maxHeight: isUnder1200px ? 'none' : '410px',
    overflow: isUnder1200px ? 'visible' : 'auto',
  }

  const { data: schoolData } = useGET_mySchoolQuery()
  const { data: subjects } = useGET_subjectsQuery({ page: 1, page_size: MAX_PER_PAGE })

  return (
    <Box sx={{ padding: '20px', paddingTop: '0px' }}>
      <Grid container rowSpacing={3} columnSpacing={3}>
        
            { schoolData &&
            <Grid item xs={12} md={12}>
              <Box sx={{ padding: '5px 20px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ flex: '0 0 calc(100% - 40px)' }}>
                    <Typography sx={{ fontSize: '1rem', fontWeight: '600' }}>Welcome to { schoolData.title }</Typography>
                  </div>
                </div>
              </Box>
            </Grid>
            }

            <Grid item xs={12} md={6} lg={4}>
                <Box className='thick-border transparent-background' sx={{
                ...topBoxStyle, 
                backgroundImage: `url(${agenda})`, 
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center right',
                backgroundSize: 'cover', 
              }}><Agenda /></Box>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Box className='thick-border transparent-background' sx={{
                ...topBoxStyle, 
                backgroundImage: `url(${calendar})`, 
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center right',
                backgroundSize: 'cover', 
              }}><AcademicCalendar /></Box>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Box sx={topBoxStyle} className='thick-border'>
                <WhatINeed />
              </Box>
            </Grid>


            <Grid item xs={12}>
              <Box className='thick-border'>
                <Courses />
              </Box>
            </Grid>


            <Grid item xs={12} md={6} lg={6} xl={4}>
              <Attendance />
            </Grid>
            {subjects && subjects.results.map(s =>
                    <Grid item xs={12} md={6} lg={6} xl={4} key={s.id}>
                    <Grades subject={s} /> 
                    </Grid>).slice(0,2)}
   
      </Grid>
    </Box>
  )
}
export default StudentDashboardPage
